export const apiTags = [
  'User',
  'Users',
  'Consumer',
  'Consumers',
  'Message',
  'Messages',
  'Operation',

  'Logs',
  'Integrations',
  'IntegrationServices',
  'Languages',
  'SecureIPS',
  'Tariff',
  'TariffFeature',
  'Invoices',
  'Invoice',
  'Announcements',
  'Announcement',
  'Settings',
  'Setting',
  'Tools',
  'Tool',
  'Artifacts',
  'Style',
  'Styles',
  'StylePrompts',
  'Models',
  'Model',
  'ModelPrices',
  'Strategy',
  'ReferralRewards',
];
